import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-phonefield', 'INVALID', 'Ievadīts nekorekts telefona numurs.');
Labels.set('ui-phonefield', 'CHOOSE_COUNTRY', 'Izvēlieties valsti');
Labels.set('ui-phonefield', 'PHONENR', 'Tālrunis');
